import React from "react";
import "./Modal.scss";
import { PropTypes } from "prop-types";

const Modal = (props) => {
  const {
    message,
    open,
    processNextStep,
    warningMessage,
    buttonText = "Next",
  } = props;

  return (
    <div className={open ? "modal-open" : "modal"}>
      <div
        style={{
          height: "100%",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* <h4>{message}</h4>
      {warningMessage ? (
        <p className="warning-message">{warningMessage}</p>
      ) : null}
      <button className="button-class" onClick={processNextStep}>
        {buttonText}
      </button> */}
        {props.children}
      </div>
    </div>
  );
};

Modal.propTypes = {};

export default Modal;
